declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, SavePurchaseOrderRequest, PurchaseOrderItemRequest, PurchaseOrderDetailsController, PurchaseOrdersListController, } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { Time } from '@angular/common';

@Component({
  selector: 'editPOVIitems2',
  templateUrl: './editPOVIitems2.modal.html',
  styleUrls: ['./editPOVIitems2.modal.scss']
})

export class NgbEditPOVIitems2Modal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  @Input() FromScreen: string;
  @Input() PurchaseOrderData: SavePurchaseOrderRequest;
  @Input() PurchaseOrderItem: PurchaseOrderItemRequest;
  @Input() VendorName: string;
  @Input() PurchaseOrderCode: string;
  @Input() ShipToLocation: string;
  //public TotalOrderQuantity: number;
  //public Tax: any
  TodayDate = new Date();
  isRequesting: boolean;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
    this.Discount();
    this.Pack();
    //this.PurchaseOrderItem.Tax = this.Tax
    //alert(this.PurchaseOrderData.SupplierCode);
    //this.PurchaseOrderItem.TotalOrderQuantity = (+this.PurchaseOrderItem.BonusQuantity) + (+this.PurchaseOrderItem.Quantity);
  }
  Pack() {
    if (this.PurchaseOrderItem.Pack == null) {
      this.PurchaseOrderItem.Pack = 1;
    }
  }
  Discount() {
    if (this.PurchaseOrderItem.PurchasePrice == null && this.PurchaseOrderItem.DiscountPercent == null) {
      this.PurchaseOrderItem.DiscountPercent = 0;
      this.PurchaseOrderItem.Discount = 0;
    }
    else {
      this.PurchaseOrderItem.Discount = ((this.PurchaseOrderItem.Quantity) * this.PurchaseOrderItem.PurchasePrice * this.PurchaseOrderItem.DiscountPercent) / 100;
    }
  }
  DiscountEvent(event: any) {
    if (event != null) {
      this.PurchaseOrderItem.Discount = ((this.PurchaseOrderItem.Quantity) * this.PurchaseOrderItem.PurchasePrice * this.PurchaseOrderItem.DiscountPercent) / 100;
    }
  }
  //Qunatitychange() {
  //  this.PurchaseOrderItem.TotalOrderQuantity
  //}
  //Qunatitychange(event: any) {
  //  if (event != null) {
      
  //    this.PurchaseOrderItem.TotalOrderQuantity = event;
  //  }
  //}
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
